<div class="container ready-for-tablet">
  <div class="profile text-center row">
    <div class="col-lg-8 offset-lg-2 col-sm-12">
      <img
        class="title-img img-fluid"
        src="/assets/images/landing-page-welcome-back.png"
        />
      <h3 class="pink-text mt-4">
        <b> Reapply For A New Octopus Tablet </b>
      </h3>
    </div>
    <form
      class="form col-sm-12 my-5 form-wrapper center-form"
      [formGroup]="reapplyForm"
      id="contract-form"
      autocomplete="off"
      octoScrollToInvalidControl
      >
      <div class="row">
        <div class="col-lg-12 col-sm-12 col-md-12 text-start">
          <h5 class="text-start">
            <b>Contact Information</b>
          </h5>
          <p class="text-start mb-4">
            Please verify your contact information is up-to-date.
          </p>
          <label>Phone Number*</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="phone-code"
                >+1</span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="tel"
                phoneMask
                [preValue]="reapplyForm.value.phone_number"
                            [phoneControl]="
                                reapplyForm.controls['phone_number']
                            "
                formControlName="phone_number"
                maxlength="14"
                />
            </div>
            @if ((reapplyForm.controls?.['phone_number'].errors?.['required'] || reapplyForm.controls?.['phone_number'].errors?.['pattern']) && (reapplyForm.controls?.['phone_number'].dirty || reapplyForm.controls?.['phone_number'].touched || submitted)) {
              <p
                class="error-msg"
                >
                Please enter valid Phone Number
              </p>
            }
            <p class="text-start text-start mt-4 mb-3">
              <b>Shipping Address</b>
            </p>
            <fieldset formGroupName="address_data">
              <section class="space-between street-aprtment-wrap">
                <section class="form-group street">
                  <label>Street Address*</label>
                  <input
                    type="text"
                    class="form-control upper-case"
                                    [ngClass]="{
                                        'no-validation': businessError
                                    }"
                    name="street"
                    formControlName="address_line"
                                    [octoGooglePlacesAutocomplete]="
                                        octoGooglePlacesAutocomplete
                                    "
                                    (change)="
                                        setFormgroup('address_data');
                                        address_data.patchValue({
                                            address_line:
                                                reapplyForm.value?.address_data.address_line?.toUpperCase()
                                        })
                                    "
                                    (blur)="
                                        address_data.patchValue({
                                            address_line:
                                                reapplyForm?.value.address_data.address_line?.toUpperCase()
                                        })
                                    "
                    />
                  @if ((address_data?.controls?.['address_line']?.dirty || address_data?.controls?.['address_line']?.touched || submitted )&& address_data?.controls?.['address_line']?.errors?.['required']) {
                    <span
                      class="error validationerror"
                      >
                      This field is required
                    </span>
                  }
                  @if (businessError) {
                    <span
                      class="error validationerror"
                      >
                      We do not ship to commercial addresses.
                      Please make sure the address is a
                      residential address
                    </span>
                  }
                </section>
                <section class="form-group apartment">
                  <label>Apt/Suite No.</label>
                  <input
                    type="text"
                    name="aprtment"
                    class="form-control no-validation upper-case"
                    formControlName="address_apartment_suite_no"
                                    [ngClass]="{
                                        error: reapplyForm?.value.address_data.address_apartment_suite_no?.includes(
                                            '#'
                                        ),
                                        success:
                                            !reapplyForm?.value.address_data.address_apartment_suite_no?.includes(
                                                '#'
                                            ) &&
                                            reapplyForm?.value.address_data
                                                .address_apartment_suite_no
                                    }"
                                    (change)="
                                        address_data.patchValue({
                                            address_apartment_suite_no:
                                                reapplyForm?.value.address_data.address_apartment_suite_no?.toUpperCase()
                                        })
                                    "
                                    (blur)="
                                        address_data.patchValue({
                                            address_apartment_suite_no:
                                                reapplyForm?.value.address_data.address_apartment_suite_no?.toUpperCase()
                                        })
                                    "
                    />
                  @if ((address_data?.controls?.['address_apartment_suite_no']?.dirty || address_data?.controls?.['address_apartment_suite_no']?.touched || submitted )&& address_data?.controls?.['address_apartment_suite_no']?.errors?.['pattern']) {
                    <span
                      class="error validationerror"
                      >
                      Apt/Suite No. should not contain special
                      character - #
                    </span>
                  }
                </section>
              </section>
              <section class="space-between">
                <section class="form-group">
                  <label>City*</label>
                  <input
                    type="text"
                    class="form-control upper-case"
                    name="city"
                    formControlName="address_city"
                                    (change)="
                                        address_data.patchValue({
                                            address_city:
                                                reapplyForm?.value.address_data.address_city.toUpperCase()
                                        })
                                    "
                    />
                  @if ((address_data.controls?.['address_city']?.dirty || address_data.controls?.['address_city']?.touched || submitted )&& address_data.controls?.['address_city']?.errors?.['required']) {
                    <span
                      class="error validationerror"
                      >
                      This field is required
                    </span>
                  }
                </section>
                <section class="form-group">
                  @if (
                    reapplyForm?.value.address_data.address_country.toLowerCase() ===
                    'ca'
                    ) {
                    <label
                      >Province*</label
                      >
                    }
                    @if (
                      reapplyForm?.value.address_data.address_country.toLowerCase() !==
                      'ca'
                      ) {
                      <label
                        >State*</label
                        >
                      }
                      <select
                        name="state"
                        class="form-control upper-case"
                        formControlName="address_state"
                                    (change)="
                                        address_data.patchValue({
                                            address_state:
                                                reapplyForm?.value.address_data.address_state.toUpperCase()
                                        })
                                    "
                        >
                        @for (state of states; track state) {
                          <option
                            [value]="state"
                            >
                            {{ state }}
                          </option>
                        }
                      </select>
                      @if ((address_data.controls?.['address_state']?.dirty || address_data.controls?.['address_state']?.touched || submitted )&& address_data.controls?.['address_state']?.errors?.['required']) {
                        <span
                          class="error validationerror"
                          >
                          This field is required
                        </span>
                      }
                    </section>
                  </section>
                  <section class="space-between">
                    <section class="form-group">
                      @if (
                        reapplyForm?.value.address_data.address_country.toLowerCase() ===
                        'ca'
                        ) {
                        <label
                          >Postal Code*</label
                          >
                        }
                        @if (
                          reapplyForm?.value.address_data.address_country.toLowerCase() !==
                          'ca'
                          ) {
                          <label
                            >Zip Code*</label
                            >
                          }
                          <input
                            class="form-control upper-case"
                            type="text"
                            formControlName="address_zip"
                            name="zip"
                                    (change)="
                                        address_data.patchValue({
                                            address_zip:
                                                reapplyForm?.value.address_data.address_zip.toUpperCase()
                                        })
                                    "
                            />
                          @if ((address_data.controls?.['address_zip']?.dirty || address_data.controls?.['address_zip']?.touched || submitted )&& address_data.controls?.['address_zip']?.errors?.['required']) {
                            <span
                              class="error validationerror"
                              >
                              This field is required
                            </span>
                          }
                          @if ((address_data.controls?.['address_zip']?.dirty || address_data.controls?.['address_zip']?.touched || submitted )&& address_data.controls?.['address_zip']?.errors?.['pattern']) {
                            <span
                              class="error validationerror"
                              >
                              Please enter valid
                              @if (
                                reapplyForm?.value.address_data.address_country.toLowerCase() ===
                                'ca'
                                ) {
                                Postal Code*
                              }
                              @if (
                                reapplyForm?.value.address_data.address_country.toLowerCase() !==
                                'ca'
                                ) {
                                Zip Code*
                              }
                            </span>
                          }
                        </section>
                        <section class="form-group">
                          <label>Country</label>
                          <!-- <input type="text" name="country" class="form-control no-validation" formControlName="address_country" [attr.readonly]="true"> -->
                          <select
                            class="form-control no-validation pe-none"
                            id="country"
                            name="country"
                            formControlName="address_country"
                            [attr.readonly]="true"
                            >
                            @for (item of countries; track item) {
                              <option
                                [value]="item.value"
                                >
                                {{ item.flag }} {{ item.label }}
                              </option>
                            }
                          </select>
                        </section>
                      </section>
                    </fieldset>
                  </div>
                  <div class="col-lg-12 col-sm-12 col-md-12 text-start mt-2">
                    <h5 class="text-start">
                      <b>Current Rideshare Information</b>
                    </h5>
                    <div class="form-group">
                      <label>Primary Rideshare Company*</label>
                      <select
                        name="primary_rideshare_employer"
                        panelClass="myPanelClass"
                        class="form-control dd-privacy-allow"
                        formControlName="primary_rideshare_employer"
                        (change)="rideShareUpdated()"
                        (click)="markTouched('primary_rideshare_employer')"
                        [ngClass]="{'error': submitted && reapplyForm.controls.primary_rideshare_employer.errors?.['required']}"
                        >
                        @for (item of rideshareEmployerOptions; track item) {
                          <option
                            [value]="item.value"
                                [disabled]="
                                    item.value !== '' &&
                                    item.value ===
                                        reapplyForm.value
                                            .secondary_rideshare_employer
                                "
                            >
                            {{ item.label }}
                          </option>
                        }
                        @if (
                          currentUser?.shipping_info?.mailing_address_country.toLowerCase() ===
                          'ca'
                          ) {
                          <option
                            value="Facedrive"
                                [disabled]="
                                    'Facedrive' ===
                                    reapplyForm.value
                                        .secondary_rideshare_employer
                                "
                            >
                            Facedrive
                          </option>
                        }
                      </select>
                      @if ((reapplyForm.controls.primary_rideshare_employer.dirty || reapplyForm.controls.primary_rideshare_employer.touched ||submitted )&& reapplyForm.controls.primary_rideshare_employer.errors?.['required']) {
                        <p
                          class="error"
                          >
                          This field is required
                        </p>
                      }
                    </div>
                    <div class="form-group">
                      <label>Secondary Rideshare Company</label>
                      <select
                        name="secondaryRide"
                        class="form-control dd-privacy-allow no-validation"
                        formControlName="secondary_rideshare_employer"
                            [ngClass]="{
                                success:
                                    reapplyForm.controls
                                        .secondary_rideshare_employer.value
                            }"
                        (change)="rideShareUpdated()"
                        >
                        @for (item of rideshareEmployerOptions; track item) {
                          <option
                            [value]="item.value"
                                [disabled]="
                                    item.value !== '' &&
                                    item.value ===
                                        reapplyForm.value
                                            .primary_rideshare_employer
                                "
                            >
                            {{ item.label }}
                          </option>
                        }
                        @if (
                          currentUser?.shipping_info?.mailing_address_country.toLowerCase() ===
                          'ca'
                          ) {
                          <option
                            value="Facedrive"
                                [disabled]="
                                    'Facedrive' ===
                                    reapplyForm.value.primary_rideshare_employer
                                "
                            >
                            Facedrive
                          </option>
                        }
                      </select>
                    </div>
                    <div id="uber_status_div">
                      @if (
                        reapplyForm.value.primary_rideshare_employer ===
                        'Uber' ||
                        reapplyForm.value
                        .secondary_rideshare_employer === 'Uber'
                        ) {
                        <div
                          class="form-group"
                          >
                          <label>Uber Status*</label>
                          <select
                            id="uberStatus"
                            name="uber_status"
                            class="form-control dd-privacy-allow no-validation"
                                [ngClass]="{
                                    success:
                                        reapplyForm.controls.uber_status.value
                                }"
                            formControlName="uber_status"
                            >
                            @for (item of uberStatusOptions; track item) {
                              <option
                                [value]="item.value"
                                >
                                {{ item.label }}
                              </option>
                            }
                          </select>
                          @if ((reapplyForm.controls.uber_status.dirty || reapplyForm.controls.uber_status.touched ||submitted) && reapplyForm.controls.uber_status.errors?.['required']) {
                            <p
                              class="error validationerror"
                              >
                              This field is required
                            </p>
                          }
                        </div>
                      }
                    </div>
                    <div class="form-group required">
                      <div class="form-group">
                        <label>Vehicle Ownership*</label>
                        <select
                          name="vehicle_ownership"
                          class="form-control dd-privacy-allow"
                          formControlName="vehicle_ownership"
                                [ngClass]="{
                                    success:
                                        reapplyForm.controls.vehicle_ownership
                                            .value
                                }"
                          (change)="onVehicleOwnerShipChange()"
                          >
                          @for (item of vehicleOwnershipOptions; track item) {
                            <option
                              [value]="item.value"
                              >
                              {{ item.label }}
                            </option>
                          }
                        </select>
                        @if ((reapplyForm.controls.vehicle_ownership.dirty || reapplyForm.controls.vehicle_ownership.touched ||submitted) && reapplyForm.controls.vehicle_ownership.errors?.['required']) {
                          <p
                            class="error validationerror"
                            >
                            This field is required
                          </p>
                        }
                      </div>
                      @if (
                        reapplyForm.value.vehicle_ownership === 'other'
                        ) {
                        <div
                          class="form-group"
                          >
                          <label>Vehicle Ownership (if Other)*</label>
                          <input
                            id="vehicleOwnershipOther"
                            mat-input
                            type="text"
                            class="form-control dd-privacy-allow no-validation"
                            formControlName="vehicle_ownership_other"
                            name="vehicle_ownership_other"
                                [ngClass]="{
                                    success:
                                        reapplyForm.controls
                                            .vehicle_ownership_other.value
                                }"
                            />
                          @if ((reapplyForm.controls.vehicle_ownership_other.dirty || reapplyForm.controls.vehicle_ownership_other.touched || submitted) && reapplyForm.controls.vehicle_ownership_other.errors?.['required']) {
                            <p
                              class="error"
                              >
                              This field is required
                            </p>
                          }
                        </div>
                      }
                    </div>
                    <div class="form-group required">
                      <label class="control-label" for="lifetime_rides"
                        >Lifetime Total Rides Given*</label
                        >
                        <input
                          type="text"
                          class="form-control dd-privacy-allow"
                          id="lifetime_trips"
                          title="Please enter only numbers and less than 999999"
                          formControlName="lifetime_rides"
                          maxlength="6"
                          />
                        @if ((reapplyForm.controls?.['lifetime_rides']?.touched || reapplyForm.controls?.['lifetime_rides']?.dirty ||submitted )&& (reapplyForm.controls?.['lifetime_rides']?.errors?.['required'] || reapplyForm.controls?.['lifetime_rides']?.errors?.['pattern'])) {
                          <p
                            class="error-msg"
                            >
                            Please enter only numbers and less than 999999
                          </p>
                        }
                      </div>
                      <div class="form-group required">
                        <label class="control-label" for="rideshare_status"
                          >Current Rideshare Status*</label
                          >
                          <select
                            [ngClass]="{
                                success:
                                    reapplyForm.controls.rideshare_status.value
                            }"
                            name="rideshare_status"
                            class="form-control dd-privacy-allow"
                            formControlName="rideshare_status"
                            >
                            @for (item of rideshareStatusOptions; track item) {
                              <option
                                [value]="item.value"
                                >
                                {{ item.label }}
                              </option>
                            }
                          </select>
                          @if ((reapplyForm.controls.rideshare_status.dirty || reapplyForm.controls.rideshare_status.touched || submitted) && reapplyForm.controls.rideshare_status.errors?.['required']) {
                            <p
                              class="error"
                              >
                              This field is required
                            </p>
                          }
                        </div>
                      </div>
                      @if (currentUser?.market === 'New York, NY') {
                        <div
                          class="col-lg-12 col-sm-12 col-md-12 text-start mt-2"
                          >
                          <h5 class="text-left">
                            <b>NYC Taxi &amp; Limousine Commission License</b>
                          </h5>
                          <div class="form-group">
                            <label
                              >Do you have a NYC Taxi &amp; Limousine Commission
                              License?*</label
                              >
                              <div>
                                <label for="hasLicenceYes"
                                  >Yes
                                  <input
                                    type="radio"
                                    id="hasLicenceYes"
                                    name="has_nyctlc_license"
                                    [value]="true"
                                    formControlName="has_nyctlc_license"
                                  /></label>
                                  <label for="hasLicenceNo" class="no-label"
                                    >No
                                    <input
                                      type="radio"
                                      id="hasLicenceNo"
                                      name="has_nyctlc_license"
                                      [value]="false"
                                      formControlName="has_nyctlc_license"
                                      checked
                                    /></label>
                                  </div>
                                  @if ((reapplyForm.controls?.['has_nyctlc_license']?.touched || reapplyForm.controls?.['has_nyctlc_license']?.dirty || submitted )&&
                                    (reapplyForm.controls?.['has_nyctlc_license']?.errors?.['required'])) {
                                    <p
                                      class="error-msg"
                                      >
                                    Please select one of these options
                                  </p>
                                }
                              </div>
                            </div>
                          }
                              <div class="col-lg-12 col-sm-12 col-md-12 text-start mt-2">
                                <h5 class="text-start">
                                  <b>Reason for Reapply*</b>
                                </h5>
                                <div class="form-group required">
                                  <label
                                    class="control-label"
                                    for="reapply_reason"
                                  ></label>
                                  <textarea
                                    class="form-control dd-privacy-allow show-validation"
                                    id="reapply_reason"
                                    maxlength="2000"
                                    name="reapply_reason"
                                    formControlName="reapply_reason"
                                  ></textarea>
                                  <span
                                    class="float-end label label-default count-message"
                                    id="count_message"
                                    >{{
                                    reapplyForm.controls.reapply_reason.value
                                    ?.length
                                    }}
                                    / 2000</span
                                    >
                                    @if ((reapplyForm.controls.reapply_reason.dirty || reapplyForm.controls.reapply_reason.touched || submitted) && reapplyForm.controls.reapply_reason.errors?.['required']) {
                                      <p
                                        class="error"
                                        >
                                        This field is required
                                      </p>
                                    }
                                  </div>

                                  <div class="checkbox">
                                    <label>
                                      <input
                                        id="agree_to_rides"
                                        name="agree_to_rides"
                                        type="checkbox"
                                        value="y"
                                        required=""
                                        formControlName="rides_agree"
                                        />
                                      I am currently doing 100 rides or more a month and
                                      I’m ready for an Octopus tablet again!*
                                      @if ((reapplyForm.controls?.['rides_agree']?.touched || reapplyForm.controls?.['rides_agree']?.dirty || submitted )&&
                                        (reapplyForm.controls?.['rides_agree']?.errors?.['required'])) {
                                        <p
                                          class="error-msg"
                                          >
                                          <small
                                            >(Please tick this box if you want to
                                            proceed)</small
                                            >
                                          </p>
                                        }
                                      </label>
                                    </div>
                                    <div class="checkbox">
                                      <label>
                                        <input
                                          id="agree_to_contract"
                                          name="agree_to_contract"
                                          type="checkbox"
                                          value="y"
                                          required=""
                                          formControlName="agree"
                                          />
                                        I agree to the
                                        <input
                                          type="button"
                                          class="btn-agreement-link"
                                          data-toggle="modal"
                                          data-target="#agreement-modal"
                                          value="Play Octopus Driver Agreement"
                                          (click)="showTermsModal('agreement')"
                                          />.*
                                          @if ((reapplyForm.controls?.['agree']?.touched || reapplyForm.controls?.['agree']?.dirty || submitted )&&
                                            (reapplyForm.controls?.['agree']?.errors?.['required'])) {
                                            <p
                                              class="error-msg"
                                              >
                                            <small
                                              >(Please tick this box if you want to
                                              proceed)</small
                                              >
                                            </p>
                                          }
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <hr />
                                  <p class="text-start">*Required Fields</p>
                                  <br />
                                  <button
                                    class="btn btn-big btn-pink btn-pink-filled fw-btn"
                                    id="btn"
                                    (click)="submitInfo()"
                                    [disabled]="submitting"
                                    >
                                    <p class="load-btn small-btn">
                                      @if (!submitting) {
                                        Continue
                                      }
                                      @if (submitting) {
                                        <mat-spinner [diameter]="17"></mat-spinner> Processing.
                                        This may take up to 20 secs
                                      }
                                    </p>
                                  </button>
                                </form>
                              </div>
                            </div>
